import React, { Component, Fragment } from 'react';
import {
  HashRouter as Router,
  Route,
  Redirect,
  Switch,
  withRouter
} from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';

import {
  ACCEPTED_LICENSE, LOAD_MONITORS_REQUEST, LOAD_PARTS_REQUEST, SET_LANGUAGE
} from 'redux/actions';

import OrderReview from './OrderReview/OrderReview';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import LicensePage from './TitlePage/LicensePage';
import LicensesPage from './TitlePage/LicensesPage';
import LoadingPage from './TitlePage/LoadingPage';
import TitlePage from './TitlePage/TitlePage';
import Configurator from './Configurator/Configurator';
import MonitorSelection from './MonitorSelection/MonitorSelection';

import './App.css';

// Sync/load status
const LOADING_STATUS_NOT_STARTED = 0;
const LOADING_STATUS_SYNC_REMOTE = 1;
const LOADING_STATUS_LOADING_DATA = 2;
const LOADING_STATUS_READY = 3;
const LOADING_STATUS_ERROR = 4;

const _AcceptLicensePage = ({ location, history, acceptLicense }) => {
  const goLicense = location.pathname.indexOf('license') >= 0;
  const onAcceptDisclaimer = () => {
    acceptLicense();
    history.push('/monitor');
  };
  return ([
    <Header key="header" location={location} showMenus />,
    (goLicense
      ? <Route key="license" path="/license" render={() => <LicensePage {...this.props} />} />
      : (
        <TitlePage
          key="title"
          onAcceptDisclaimer={onAcceptDisclaimer}
        />
      )
    ),
    <Route key="licenses" path="/licenses" render={() => <LicensesPage {...this.props} />} />
  ]);
};

_AcceptLicensePage.propTypes = {
  acceptLicense: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired
};

const AcceptLicensePage = withRouter(connect(
  state => ({
    order: state.order,
    monitors: state.monitors,
    parts: state.parts,
    strings: state.strings,
    preferences: state.preferences
  }),
  dispatch => ({
    acceptLicense: (acceptedLicense = true) => dispatch({ type: ACCEPTED_LICENSE, acceptedLicense })
  })
)(_AcceptLicensePage));

class App extends Component {
  constructor(props) {
    super(props);

    // first, fetch the static data
    this.loadingStatus = LOADING_STATUS_NOT_STARTED;
  }

  componentDidMount() {
    // TODO, move parts and monitors fetching into sagas to clean this up
    const {
      loadMonitors, loadParts, preferences, setLanguage
    } = this.props;
    // load data
    loadMonitors();
    loadParts();
    setLanguage(preferences.language || 'EN');

    this.loadingStatus = LOADING_STATUS_LOADING_DATA;
  }

  checkLoadingStatus() {
    const { monitors, parts, strings } = this.props;
    if (this.loadingStatus === LOADING_STATUS_LOADING_DATA) {
      if (!monitors.isFetching
        && !parts.isFetching
        && !strings.isFetching) {
        return LOADING_STATUS_READY;
      }
    }

    return this.loadingStatus;
  }

  render() {
    const { preferences } = this.props;
    const readyRoutes = () => (preferences.acceptedLicense ? ([
      <Route
        key="header"
        path="/"
        render={({ location }) => (
          location.pathname !== '/' ? <Header location={location} /> : null
        )}
      />,
      <Switch key="switch">
        <Route key="monitor" path="/monitor/:familyId?" render={({ match }) => <MonitorSelection familyId={match.params.familyId} />} />
        <Route key="config" path="/config/:monitorId" render={({ match }) => <Configurator monitorId={match.params.monitorId} />} />
        <Route key="review" path="/review" component={OrderReview} />
        <Route key="licenses" path="/licenses" render={() => <LicensesPage {...this.props} />} />
        <Route key="license" path="/license" render={() => <LicensePage {...this.props} />} />
      </Switch>,
      <Footer key="footer" />
    ]) : ([
      <Route
        key="header"
        path="/"
        render={({ location }) => (
          location.pathname !== '/' ? <Redirect to="/" /> : null
        )}
      />
    ]));

    this.loadingStatus = this.checkLoadingStatus();
    return (
      <Router basename="/">
        <div className="wrapper">
          {this.loadingStatus < LOADING_STATUS_READY ? (
            <Route
              path="/"
              render={() => (
                [
                  <Header key="header" showMenus={false} />,
                  <LoadingPage key="loading" status={this.loadingStatus} />
                ]
              )}
            />
          ) : (
            <Fragment>
              <Route
                key="show-disclaimer"
                exact
                path="/"
                render={({ location }) => (
                  <AcceptLicensePage
                    location={location}
                    {...this.props}
                  />
                )}
              />
              { readyRoutes() }
            </Fragment>
          )}
        </div>
      </Router>
    );
  }
}

App.defaultProps = {};
App.propTypes = {
  loadMonitors: PropTypes.func.isRequired,
  loadParts: PropTypes.func.isRequired,
  setLanguage: PropTypes.func.isRequired,
  monitors: PropTypes.shape().isRequired,
  parts: PropTypes.shape().isRequired,
  preferences: PropTypes.shape().isRequired,
  strings: PropTypes.shape().isRequired
};

export default connect(
  state => ({
    order: state.order,
    monitors: state.monitors,
    parts: state.parts,
    strings: state.strings,
    preferences: state.preferences
  }),
  dispatch => ({
    loadMonitors: () => dispatch({ type: LOAD_MONITORS_REQUEST }),
    loadParts: () => dispatch({ type: LOAD_PARTS_REQUEST }),
    setLanguage: languageCode => dispatch(
      { type: SET_LANGUAGE, languageCode }
    )
  })
)(App);
